const selectors = {
  overlay: "[data-360]",
  overlayTrigger: "[data-360-trigger]",
  overlayDialog: "[data-360-dialog]",
  overlayContainer: "[data-360-container]",
};

// const init360View = (container, url) =>
//   new VRView.Player(container, {
//     image: url,
//   });

const init360Overlay = (overlay: any) => {
  const overlayTrigger = overlay.querySelector(selectors.overlayTrigger);
  const overlayDialog = overlay.querySelector(selectors.overlayDialog);

  // let vrViewPlayer = init360View(
  //   selectors.overlayContainer,
  //   overlayTrigger.getElementsByTagName("a")[0].href
  // );

  overlayTrigger.addEventListener("click", (e: Event) => {
    e.preventDefault();
    e.stopPropagation();

    overlayDialog.showModal();
  });
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    const overlays = document.querySelectorAll(selectors.overlay);

    overlays?.forEach(init360Overlay);
  },
  {
    once: true,
  }
);
